<div *ngIf="formattedFrom && formattedTo" class="maintenance-wrapper">
  <div class="maintenance-card">
    <h1>{{ 'MAINTENANCE_TITLE' | translate }}</h1>
    <p> {{ 'MAINTENANCE_MESSAGE' | translate:{ timeFrom: formattedFrom, timeTo: formattedTo } }}</p>

    <button *ngIf="isAdmin" class="admin-btn" (click)="onAdminContinue()">
      {{ 'MAINTENANCE_BUTTON' | translate }}
    </button>
  </div>
</div>
